// Profile Skeleton Component
// Loading placeholder for better UX

import React from 'react';
import styles from './ProfileSkeleton.module.css';

const ProfileSkeleton = () => {
  return (
    <div className={styles.container}>
      {/* Cover Photo Skeleton */}
      <div className={styles.coverPhoto}>
        <div className={styles.shimmer} />
      </div>

      {/* Profile Header Skeleton */}
      <div className={styles.header}>
        <div className={styles.profilePicture}>
          <div className={styles.shimmer} />
        </div>
        
        <div className={styles.headerInfo}>
          <div className={styles.nameSkeleton}>
            <div className={styles.shimmer} />
          </div>
          <div className={styles.headlineSkeleton}>
            <div className={styles.shimmer} />
          </div>
          <div className={styles.locationSkeleton}>
            <div className={styles.shimmer} />
          </div>
        </div>

        <div className={styles.actionButtons}>
          <div className={styles.buttonSkeleton}>
            <div className={styles.shimmer} />
          </div>
          <div className={styles.buttonSkeleton}>
            <div className={styles.shimmer} />
          </div>
        </div>
      </div>

      {/* Tab Navigation Skeleton */}
      <div className={styles.tabs}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={styles.tabSkeleton}>
            <div className={styles.shimmer} />
          </div>
        ))}
      </div>

      {/* Content Skeleton */}
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>
            <div className={styles.shimmer} />
          </div>
          
          <div className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.textLine}>
                <div className={styles.shimmer} />
              </div>
              <div className={styles.textLine} style={{ width: '80%' }}>
                <div className={styles.shimmer} />
              </div>
              <div className={styles.textLine} style={{ width: '60%' }}>
                <div className={styles.shimmer} />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionTitle}>
            <div className={styles.shimmer} />
          </div>
          
          <div className={styles.gridContainer}>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={styles.gridItem}>
                <div className={styles.shimmer} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// Tab skeleton component for lazy loading
export const TabSkeleton = () => {
  return (
    <div className={styles.tabContent}>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>
          <div className={styles.shimmer} />
        </div>
        
        <div className={styles.card}>
          <div className={styles.cardContent}>
            <div className={styles.textLine}>
              <div className={styles.shimmer} />
            </div>
            <div className={styles.textLine} style={{ width: '90%' }}>
              <div className={styles.shimmer} />
            </div>
            <div className={styles.textLine} style={{ width: '70%' }}>
              <div className={styles.shimmer} />
            </div>
            <div className={styles.textLine} style={{ width: '85%' }}>
              <div className={styles.shimmer} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle} style={{ width: '150px' }}>
          <div className={styles.shimmer} />
        </div>
        
        <div className={styles.listContainer}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.listItem}>
              <div className={styles.listIcon}>
                <div className={styles.shimmer} />
              </div>
              <div className={styles.listContent}>
                <div className={styles.textLine} style={{ width: '70%' }}>
                  <div className={styles.shimmer} />
                </div>
                <div className={styles.textLine} style={{ width: '50%' }}>
                  <div className={styles.shimmer} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;
